<template>
  <v-layout>
    <div class="col">
      <div class="head-page-title hide-for-small-only">
        <h1 class="main-title">{{ this.$t('serviceAndContact.service-contact-title') }}</h1>
      </div>
      <div class="panel">
        <div class="overview-content">
          <div class="contactlist">
            <ul>
              <li>{{ this.$t('serviceAndContact.by-email') }}</li>
              <li>
                <a :href="'mailto://' + emailAddress" class="button alt">
                  {{ emailAddress }}
                </a>
              </li>
              <li>{{ this.$t('serviceAndContact.call-customer-service') }}</li>
              <li>
                <a href="#" class="button alt" style="cursor: default;">
                  {{ phoneNumber }}
                </a>
              </li>
              <li>{{ this.$t('serviceAndContact.request-personal-contact') }}</li>
              <li>
                <a :href="contactFormLink" class="button alt" target="_blank">
                  {{ this.$t('serviceAndContact.contact-form') }}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </v-layout>
</template>

<script>
import VLayout from '../layouts/Default'

export default {
  name: 'ServiceAndContactPage',
  components: {
    VLayout
  },
  data: () => ({
    emailAddress: 'klantenservice.zakelijk@arriva.nl',
    phoneNumber: '088 - 277 72 72',
    contactFormLink: ''
  }),
  created () {
    this.contactFormLink = this.$container.config.arrivaXcEndpoint + '/zakelijk/contact.htm'
  }
}
</script>



// WEBPACK FOOTER //
// src/views/ServiceAndContactPage.vue